import React from "react";
import { Link } from "react-router-dom";

import images from "assets/images";
import { indexRoute } from "constants/routes";

export const Logo = () => (
  <div>
    <Link to={indexRoute}>
      <img alt="Homepage" className="logo--full" src={images.logoFull} />
      <img alt="Homepage" className="logo--symbol" src={images.logoSymbol} />
    </Link>
  </div>
);



// WEBPACK FOOTER //
// ./src/components/Logo.jsx